module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzkwQ0FGOSIgZD0iTTQwIDQ1SDhWM2gyMmwxMCAxMHoiLz48cGF0aCBmaWxsPSIjRTFGNUZFIiBkPSJNMzguNSAxNEgyOVY0LjV6Ii8+PHBhdGggZD0iTTE2IDIxaDE3djJIMTZ6bTAgNGgxM3YySDE2em0wIDRoMTd2MkgxNnptMCA0aDEzdjJIMTZ6IiBmaWxsPSIjMTk3NkQyIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/file.svg
// module id = 4176
// module chunks = 0